
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/forms/form8";
import { GetInstructionFile } from '@/components/utils/GetInstructionFile';
const form8State = namespace("Form8");

@Component
export default class Rule62ApplicationInstructions extends Vue {   

    @form8State.Action
    public UpdateCurrentNoticeOfApplicationToVaryId!: (newCurrentNoticeOfApplicationToVaryId: string) => void

    affidavit = false;

    mounted(){
        this.affidavit = false;
    }

    public startNewForm8Document(){
        this.UpdateCurrentNoticeOfApplicationToVaryId(null);
        this.$router.push({name: "start-form8" })
    }

    public downloadInstructions(pdf_name){

        GetInstructionFile(pdf_name);
        
    }

}

